import { Moment } from 'moment';
import { dataMember, required, typedArray } from 'santee-dcts';
import { deserializers } from '../../../core';

export class AdminEmailNotificationAlertReport {

    @dataMember()
    @required()
    public documentType: string;

    @dataMember()
    @required({ nullable: true })
    public protocolName: string;

    @dataMember()
    @required({ nullable: true })
    public projectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public siteNum: string;

    @dataMember()
    @required({ nullable: true })
    public description: string;

    @dataMember()
    @required()
    public notifyType: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required()
    public emailDateTime: Moment;

    @dataMember()
    @required()
    public emailSentTo: string;

}

export class AdminEmailNotificationAlertReportReadModel {
    @dataMember()
    @required()
    @typedArray(AdminEmailNotificationAlertReport)
    public reports: AdminEmailNotificationAlertReport[];
}